import React from "react";

import Banner from "../../components/UserSideComponents/abouts/Banner";
import Details from "../../components/UserSideComponents/abouts/Details";
// import Occupancies from "../../components/UserSideComponents/abouts/Occupancies";
import Amenities from "../../components/UserSideComponents/abouts/Amenities";
import Similar_properties from "../../components/UserSideComponents/abouts/Similar_properties";
import TouchWithUs from "../../components/UserSideComponents/Home/TouchWithUs";
import Body from "../../components/UserSideComponents/abouts/Body";

// import "../../../../client/src/App.css";

const About = () => {
  return (
    <>
      <Banner title="About Us" />
      <Body />
      <TouchWithUs />
    </>
  );
};

export default About;
